import React, { Component } from 'react';
import { bool } from 'prop-types';
import Header from './Header/Header';
import ThemeWatcher from './ThemeWatcher';
import MobileMenu from './MobileMenu';
import { connect } from 'react-redux';
import cn from 'classnames';
import { setMenuClose } from '../redux/mobileMenu/mobileMenuActions';
import { Mobile } from '../utils/responsiveQueries';
import { getFlagProperty } from '../redux/flags/flags';
import { TriggerOnScroll } from '../elements';

const mapStateToProps = (state) => {
  return {
    isMenuOpen: state.mobileMenu.isMenuOpen,
    isHeaderHome: getFlagProperty(state, 'isHeaderHome'),
    isPageAnimationsUnblocked: getFlagProperty(state, 'isPageAnimationsUnblocked'),
  };
};

const mapDispatchToProps = {
  setMenuClose,
};

class Workspace extends Component {
  static propTypes = {
    isMenuOpen: bool,
    isHeaderHome: bool,
    isPageAnimationsUnblocked: bool,
  };

  constructor(props) {
    super(props);
    this.mql = window.matchMedia('(max-width: 767px)');
  }

  toggleMenu = (e) => {
    !e.matches && this.props.setMenuClose();
  };

  componentDidMount() {
    this.mql.addEventListener('change', this.toggleMenu);
  }
  componentWillUnmount() {
    this.mql.removeEventListener('change', this.toggleMenu);
  }

  render() {
    const { isHeaderHome, isPageAnimationsUnblocked } = this.props;
    return (
      <div
        className={cn('container', {
          'is-menu-active': this.props.isMenuOpen,
        })}
      >
        <ThemeWatcher />
        <div className="content">
          <TriggerOnScroll bypass={!isHeaderHome || !isPageAnimationsUnblocked}>
            <Header />
          </TriggerOnScroll>
          {this.props.children}
        </div>
        <Mobile>
          <MobileMenu />
        </Mobile>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Workspace);
